export default __webpack_public_path__ + "static/media/testimonial_bg_shap.fa61398b.png";